// 자동 복기 설정 자격 조회 — MY 탭 진입 행 노출 판정용 (2026-08-28)
//
// 왜 자격을 물어보나: 서버 스위퍼는 허용리스트 또는 국밥 티어가 아닌 계정을
// not_entitled로 걸러낸다. 자격 없는 계정에 설정 행을 보여주면 "켰는데 안 도는" 상태가 된다
// → 효신님 결정(2026-08-28): 자격 없으면 진입 행 자체를 숨긴다.
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../lib/api";
import { useAuth } from "../lib/useAuth";

export type ReviewAutoState = {
  entitled: boolean;
  entitlement: "allowlist" | "gukbap" | null;
  killSwitch: boolean;
  debateCost: number;
  defaultMonthlyCap: number;
  schedule: {
    enabled: boolean;
    debate_enabled: boolean;
    run_minute_kst: number;
    last_run_date_kst: string | null;
    monthly_debate_cap: number | null;
  };
  month: { key: string; cap: number | null; used: number; remaining: number | null; exhausted: boolean };
  nextRun: { day: "today" | "tomorrow"; minute: number; imminent: boolean } | null;
};

export function useReviewAuto() {
  const { user } = useAuth();
  return useQuery<ReviewAutoState>({
    queryKey: ["review-auto"],
    queryFn: () => apiFetch<ReviewAutoState>("/api/mobile/sim/review-auto"),
    enabled: !!user,
    staleTime: 5 * 60_000, // 자격·설정은 자주 바뀌지 않는다 — MY 탭 재진입마다 재조회하지 않는다
    retry: 1,
  });
}
